import { combineReducers } from 'redux';
import schoolRollReducer from './containers/school-roll/reducer';
import studentRollReducer from './containers/student-roll/reducer';
import teacherRollReducer from './containers/teacher-roll/reducer';
import classRollReducer from './containers/class-roll/reducer';
import quickUploadReducer from './containers/quick-upload/reducer';
import editStudentReducer from './containers/edit-student/reducer';
import assignUserReducer from './containers/assign-user/reducer';
import editTeacherReducer from './containers/edit-teacher/reducer';
import editClassReducer from './containers/edit-class/reducer';
import rolloverReducer from './containers/roll-over/reducer';
import toastReducer from './components/toast/reducer';
import extendResultReducer from './containers/extend-result/reducer';
import downloadCertificatesReducer from './containers/download-certificates/reducer';
import signInCardsReducer from './containers/sign-in-cards/reducer';
import defaultCoursesReducer from './containers/default-course/reducer';
import languageProviderReducer from './containers/language-provider/reducer';
import teacherViewReducer from './containers/teacher-view/reducer';
import assignCoursesReducer from './containers/assign-courses/reducer';
import assignUPFCoursesReducer from './containers/assign-courses-upf/reducer';
import assignConquestCoursesReducer from './containers/assign-courses-conquest/reducer';
import assignLegacyCoursesReducer from './containers/assign-courses-legacy/reducer';
import manageAssignedCoursesReducer from './containers/manage-assigned-courses/reducer';
import courseAdminReducer from './containers/manage-default-courses/reducer';

const reducers = combineReducers({
    product: state => ({ ...state }),
    language: languageProviderReducer,
    toast: toastReducer,
    schoolRoll: schoolRollReducer,
    studentRoll: studentRollReducer,
    teacherRoll: teacherRollReducer,
    classRoll: classRollReducer,
    quickUpload: quickUploadReducer,
    editStudent: editStudentReducer,
    assignUser: assignUserReducer,
    editTeacher: editTeacherReducer,
    editClass: editClassReducer,
    rollOver: rolloverReducer,
    extendResult: extendResultReducer,
    defaultCourses: defaultCoursesReducer,
    downloadCertificates: downloadCertificatesReducer,
    signInCards: signInCardsReducer,
    teacherView: teacherViewReducer,
    assignCourses: assignCoursesReducer,
    assignCourseAdmin: manageAssignedCoursesReducer,
    courseAdmin: courseAdminReducer,
    assignUPFCourses: assignUPFCoursesReducer,
    assignConquestCourses: assignConquestCoursesReducer,
    assignLegacyCourses: assignLegacyCoursesReducer
});

export default reducers;



// WEBPACK FOOTER //
// ./app/reducers.js